import { waitForTurboBridge, isNativeApp } from "./native_helpers"

export const navigateTo = (url, options) => {
  if (options.turbo === false) {
    if (options.frame === "_top") {
      window.top.location.href = url
    } else {
      document.location.href = url
    }
  } else {
    visitWithTurboWhenReady(url, options)
  }
}

export const reload = () => {
  window.location.reload()
}

export const goBack = () => {
  history.go(-1)
}

export const refresh = () => {
  Turbo.session.refresh(document.baseURI)
}

export const exemptFromCache = () => {
  Turbo.cache.exemptPageFromCache()
}

export const recede = () => {
  Turbo.cache.clear()
  goBack()
}

export const clearCache = () => {
  Turbo.cache.clear()
}

export const visitWithTurboWhenReady = async (url, options) => {
  if (isNativeApp()) {
    await waitForTurboBridge()
  }

  // We use queueMicrotask to ensure that the visit is performed after the current event loop iteration.
  // This ensures that any cookies set eg. by a Turbo Stream will be processed before doing the visit.
  queueMicrotask(() => {
    Turbo.visit(url, options)
  })
}
